import React from 'react';import { FormTab, Show, TabbedForm, usePermissions, useShowController } from 'react-admin';
import DocumentTitle from '../common/documentTitle/DocumentTitle';
// import DescriptionTabForm from "./DescriptionTabForm";
// import CreateWinnerGeneralTabForm from "./GeneralTabForm";
import { checkPermission } from '../../helpers/checkPermissions';
import FooterRotationLogoText from './components/footer-rotation-logo-text';
import RenderComponent from './render-component';

const ViewWidget = (props) => {
  const { permissions } = usePermissions();
  const controllerProps = useShowController<any>(props);

  if (!controllerProps.record) {
    return null;
  }

  const data = controllerProps.record.data;
  const image = (data.images && data.images.length && data.images[0]) || null;

  return (
    <>
      <DocumentTitle core='Widgets' purpose={`${controllerProps.record.name}`} appointment='' />

      <Show {...props} hasEdit={true}>
        <TabbedForm toolbar={<></>}>
          <FormTab label='Description'>
            <RenderComponent
              widget={controllerProps.record}
              widgetType={controllerProps.record.type}
              widgetData={{
                text: controllerProps.record.data.text,
                fontSize: controllerProps.record.data.fontSize,
                letterSpacing: controllerProps.record.data.letterSpacing,
                image: image,
              }}
            />
          </FormTab>
        </TabbedForm>
      </Show>
    </>
  );
};
export default ViewWidget;
